import { createRecipe } from '../__generated/implementation.js';
import { AnchorPointPosition, Finish, FinishDirection, RawMaterial, StrikePlateShapeType, StrikeTonguePosition } from '../__generated/model/index.js';
const defaultThickness = 1.2;
const getCenterAnchorPointRecipes = (shapeId, offset = 0)=>[
        createRecipe({
            id: `AnchorPoint-${offset + 1}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.center,
            shapeId
        })
    ];
const getEdgeAnchorPointRecipes = (shapeId, offset = 0)=>[
        createRecipe({
            id: `AnchorPoint-${offset + 2}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.topLeft,
            shapeId
        }),
        createRecipe({
            id: `AnchorPoint-${offset + 3}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.topRight,
            shapeId
        }),
        createRecipe({
            id: `AnchorPoint-${offset + 4}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.bottomRight,
            shapeId
        }),
        createRecipe({
            id: `AnchorPoint-${offset + 5}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.bottomLeft,
            shapeId
        })
    ];
const getCornerAnchorPointRecipes = (shapeId, offset = 0)=>[
        createRecipe({
            id: `AnchorPoint-${offset + 9}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.top,
            shapeId
        }),
        createRecipe({
            id: `AnchorPoint-${offset + 6}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.bottom,
            shapeId
        }),
        createRecipe({
            id: `AnchorPoint-${offset + 7}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.left,
            shapeId
        }),
        createRecipe({
            id: `AnchorPoint-${offset + 8}`,
            type: 'AnchorPoint',
            position: AnchorPointPosition.right,
            shapeId
        })
    ];
export const getRoundShapeAnchorPointRecipes = (shapeId, offset = 0)=>[
        ...getCenterAnchorPointRecipes(shapeId, offset),
        ...getEdgeAnchorPointRecipes(shapeId, offset)
    ];
export const getRectangularShapeAnchorPointRecipes = (shapeId, offset = 0)=>[
        ...getCenterAnchorPointRecipes(shapeId, offset),
        ...getEdgeAnchorPointRecipes(shapeId, offset),
        ...getCornerAnchorPointRecipes(shapeId, offset)
    ];
// TODO: create presets can now be used
export const ProductPresets = [
    {
        name: 'Empty Square Plate',
        description: 'Empty square plate with default dimensions',
        rootEntityType: 'SquarePlate',
        img: './presets/preset-1.png',
        initialDomainEntities: [
            {
                id: 'SquarePlate-1',
                type: 'SquarePlate',
                sideLength: 150,
                thickness: defaultThickness,
                cornerRadius: 20,
                rawMaterial: RawMaterial.ss304,
                finish: Finish.brushed,
                finishDirection: FinishDirection.horizontal,
                quantity: 1,
                handing: 'standard',
                powderCoating: false,
                usage: '',
                powderCoatingMountingHoleId: null,
                hasBend: false
            },
            ...getRectangularShapeAnchorPointRecipes('SquarePlate-1')
        ]
    },
    {
        name: 'Empty Rectangular Plate',
        description: 'Empty rectangular plate with default dimensions',
        rootEntityType: 'RectangularPlate',
        img: './presets/preset-rectangular-blank.png',
        initialDomainEntities: [
            {
                id: 'RectangularPlate-1',
                type: 'RectangularPlate',
                horizontalLength: 100,
                verticalLength: 200,
                thickness: defaultThickness,
                cornerRadius: 0.5,
                rawMaterial: RawMaterial.ss304,
                finish: Finish.brushed,
                finishDirection: FinishDirection.horizontal,
                quantity: 1,
                handing: 'standard',
                powderCoating: false,
                usage: '',
                powderCoatingMountingHoleId: null,
                hasBend: false
            },
            ...getRectangularShapeAnchorPointRecipes('RectangularPlate-1')
        ]
    },
    {
        name: 'Empty Round Plate',
        description: 'Empty round plate with default dimensions',
        rootEntityType: 'RoundPlate',
        img: './presets/preset-round-blank.png',
        initialDomainEntities: [
            {
                id: 'RoundPlate-1',
                type: 'RoundPlate',
                diameter: 150,
                thickness: defaultThickness,
                rawMaterial: RawMaterial.ss304,
                finish: Finish.brushed,
                finishDirection: FinishDirection.horizontal,
                quantity: 1,
                handing: 'standard',
                powderCoating: false,
                usage: '',
                powderCoatingMountingHoleId: null
            },
            ...getRoundShapeAnchorPointRecipes('RoundPlate-1')
        ]
    },
    {
        name: 'Empty Kick Plate',
        description: 'Empty kick plate with default dimensions',
        rootEntityType: 'KickPlate',
        img: './presets/preset-kick-blank.png',
        initialDomainEntities: [
            {
                id: 'KickPlate-1',
                type: 'KickPlate',
                horizontalLength: 820,
                verticalLength: 300,
                cornerRadius: 0.5,
                thickness: defaultThickness,
                rawMaterial: RawMaterial.ss304,
                finish: Finish.brushed,
                finishDirection: FinishDirection.horizontal,
                quantity: 1,
                handing: 'standard',
                powderCoating: false,
                usage: '',
                powderCoatingMountingHoleId: null
            },
            ...getRectangularShapeAnchorPointRecipes('KickPlate-1')
        ]
    },
    {
        name: 'Empty Strike Plate',
        description: 'Empty Strike plate with default dimensions',
        rootEntityType: 'StrikePlate',
        img: './presets/preset-strike-blank.png',
        initialDomainEntities: [
            {
                id: 'StrikePlate-1',
                type: 'StrikePlate',
                shapeType: StrikePlateShapeType.TStrike,
                horizontalLength: 100,
                verticalLength: 200,
                mainCornerRadius: 0.5,
                tongueHorizontalLength: 50,
                tongueOffsetStart: 25,
                tongueOffsetEnd: 25,
                tongueCornerRadius: 0.5,
                jointCornerRadius: 0.5,
                tonguePosition: StrikeTonguePosition.right,
                thickness: defaultThickness,
                rawMaterial: RawMaterial.ss304,
                finish: Finish.brushed,
                finishDirection: FinishDirection.horizontal,
                quantity: 1,
                handing: 'standard',
                powderCoating: false,
                usage: '',
                powderCoatingMountingHoleId: null,
                hasBend: true,
                bendType: 'ir11'
            },
            ...getRectangularShapeAnchorPointRecipes('StrikePlate-1'),
            {
                id: 'StrikeBend-1',
                type: 'StrikeBend'
            },
            ...getRectangularShapeAnchorPointRecipes('StrikeBend-1', 9)
        ]
    }
];

//# sourceMappingURL=plate.presets.js.map